import React from 'react';
import { isNLD_OR_LL } from 'common/constants/app.constants';
import Input from 'b2b-ui-components-lib/lib/components/input';

export const IPAttributesSection = ({ rowData }) => {
  if (isNLD_OR_LL()) {
    return null;
  }

  return (
    <>
      <div className="select_info">
        <div className="text">Internet Protocol (IP) Attributes </div>
        <div className="tooltip_wrap">
          <span className="material-icons-outlined">info</span>
          <div className="tooltip">
            <div className="tooltip_content">Internet Protocol (IP) Attributes</div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="flg-lg-6 flg-md-6">
          <Input name="IP Version" type="text" value={rowData.ipVersion ? rowData.ipVersion : 'N/A'} label="IP Version" required disabled />
        </div>
        <div className="flg-lg-6 flg-md-6">
          <Input name="Routing Protocol " type="text" value={rowData.routingProtocol ? rowData.routingProtocol : 'N/A'} label="Routing Protocol" required disabled />
        </div>
      </div>
      <div className="row">
        <div className="flg-lg-6 flg-md-6">
          <Input name="IP Type" type="text" value={rowData.ipType ? rowData.ipType : 'N/A'} label="IP Type" required disabled />
        </div>
        <div className="flg-lg-6 flg-md-6">
          <Input name="Number of WAN" type="text" value={rowData.noOfWAN ? rowData.noOfWAN : 'N/A'} label="Number of WAN" required disabled />
        </div>
      </div>
      <div className="row">
        <div className="flg-lg-6 flg-md-6">
          <Input name="Number of LAN" type="text" value={rowData.noOfLAN ? rowData.noOfLAN : 'N/A'} label="Number of LAN" required disabled />
        </div>
        <div className="flg-lg-6 flg-md-6">
          <Input name="LAN IP V4 Subnet" type="text" value={rowData.lanIPSubnet ? rowData.lanIPSubnet : 'N/A'} label="LAN IP V4 Subnet" required disabled />
        </div>
      </div>
      <div className="row">
        <div className="flg-lg-6 flg-md-6">
          <Input name="WAN IP V4 Subnet" type="text" value={rowData.wanIPSubnet ? rowData.wanIPSubnet : 'N/A'} label="WAN IP V4 Subnet" required disabled />
        </div>
      </div>
      <div className="row">
        <div className="flg-lg-6 flg-md-6">
          <Input name="WAN IP V6 Subnet" type="text" value="/126" label="WAN IP V6 Subnet" required disabled />
        </div>
      </div>
    </>
  );
};
